export default __webpack_public_path__ + "static/media/sample1.52f02eee.jpeg";